import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(1),
    overflowX: 'auto',
    overflowY: 'hidden',
    alignItems: 'center',
    '&::-webkit-scrollbar': {
      height: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.grey[400],
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.grey[600],
    },
  },
  tag: {
    flexShrink: 0,
    cursor: 'default',
  },
}));
